import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { AdminDashboardView } from 'shared';
import { adminApi } from '@/api';

export const useAdminDashboardStore = defineStore('admin-dashboard', () => {
  const days = ref<7 | 30 | 90>(30);
  const dashboard = ref<AdminDashboardView>();
  const loading = ref(false);
  const refreshing = ref(false);
  const error = ref('');

  async function load(): Promise<void> {
    const initial = !dashboard.value;
    if (initial) loading.value = true;
    else refreshing.value = true;
    error.value = '';
    try {
      dashboard.value = await adminApi.get<AdminDashboardView>(
        `/admin/dashboard?days=${days.value}`,
      );
    } catch {
      error.value = '数据看板加载失败，请确认权限和后台服务状态后重试。';
    } finally {
      loading.value = false;
      refreshing.value = false;
    }
  }

  async function changeDays(value: 7 | 30 | 90): Promise<void> {
    if (days.value === value) return;
    days.value = value;
    await load();
  }

  return { days, dashboard, loading, refreshing, error, load, changeDays };
});
